/** Shared provider/client labels for portal appointment Tasks (no task-module imports). */

export function formatAppointmentRequestTaskDescriptionForClient(label?: string): string {
  const name = label?.trim();
  return name ? `Appointment Request - ${name}` : 'Appointment Request';
}

export function formatAppointmentRequestTaskDescriptionForProvider(clientName?: string): string {
  const name = clientName?.trim();
  return name ? `Appointment Request - ${name}` : 'Appointment Request';
}

export function formatRescheduleRequestTaskDescriptionForProvider(clientName?: string): string {
  const name = clientName?.trim();
  return name ? `Reschedule Request - ${name}` : 'Reschedule Request';
}
